import { UseMutationOptions, useMutation } from 'react-query';

import { UpdateTeamMember } from '@pimm/services/lib/sms-workforce/services';
import type { UpdateTeamMemberRequest } from '@pimm/services/lib/sms-workforce/types';
import type { TeamMember } from '../types';

// PUT /api/Workforce/TeamMembers — every field beyond employeeId is optional;
// null-means-skip, empty-string-means-clear (server contract). The response
// is always the complete refreshed record, so callers should replace their
// cached row with it directly rather than patching individual fields.
export type UpdateTeamMemberVars = UpdateTeamMemberRequest & { employeeId: string };

export const useUpdateTeamMember = (options?: UseMutationOptions<TeamMember, unknown, UpdateTeamMemberVars>) =>
  useMutation({
    mutationFn: async (vars: UpdateTeamMemberVars) => (await UpdateTeamMember(vars)) as TeamMember,
    ...options,
  });
